
export default {
    // 判断地址栏出现微信自己加的参数问题
    isWeChatUrl () {
      // debugger;
        let url = window.location.href;
        let matchResult = url.match(/\?/g);
        // 如果地址栏中，出现了两个问号的话，那么是微信在分享添加了参数
        // 如果地址栏中，出现了form=,那么就是微信分享添加的参数
        return (matchResult ? matchResult.length >= 2 : false) || (/from=/.test(url));
    },
    // 把地址栏的中微信追加的参数去掉，返回我们自己项目的地址
    getProjectUrl () {
        let location = window.location;
        return location.origin + location.pathname + location.hash;
    }
};


// WEBPACK FOOTER //
// ./src/assets/js/restoreUrl.js